import {
    getLoyaltyConfig,
    updateLoyaltyConfig,
} from '../../services/api/loyaltyConfigApi';
import {
    GET_LOYALTY_CONFIG,
    UPDATE_EDITOR_FIELD,
    UPDATE_LOYALTY_CONFIG,
} from './actionTypes';
import { hideLoading, showLoading } from './loadingActions';
import { notifyError, notifySuccess } from './notificationActions';

export const getLoyaltyConfigAction = (loyaltyConfigItems) => {
    return {
        type: GET_LOYALTY_CONFIG,
        loyaltyConfigItems,
    };
};

export const updateLoyaltyConfigAction = (loyaltyConfigItem) => {
    return {
        type: UPDATE_LOYALTY_CONFIG,
        loyaltyConfigItem,
    };
};
export const updateConfigValue = (id, field, value) => {
    return {
        type: UPDATE_EDITOR_FIELD,
        id,
        field,
        value,
    };
};

export function getLoyaltyConfigItems() {
    return function (dispatch, getState) {
        const { auth } = getState();
        const { market, category, brand } = auth?.user;

        return Promise.resolve()
            .then(() => dispatch(showLoading()))
            .then(() => getLoyaltyConfig(market, category, brand))
            .then((result) => dispatch(getLoyaltyConfigAction(result.data)))
            .catch((error) => dispatch(notifyError('Error', 'Unable to get the config items')))
            .finally(() => dispatch(hideLoading()));
    };
}

export function updateLoyaltyConfigItems(loyaltyConfigs) {
    return function (dispatch, getState) {
        const { auth } = getState();
        const { market, category, brand } = auth?.user;

        return Promise.resolve()
            .then(() => dispatch(showLoading()))
            .then(() =>
                updateLoyaltyConfig(market, category, brand, loyaltyConfigs)
            )
            .then((result) => dispatch(getLoyaltyConfigItems()))
            .then(() => dispatch(notifySuccess('Success', 'Updated the config items successfully')))
            .catch((err) => dispatch(notifyError('Error', 'Unable to update the config items')))
            .finally(() => dispatch(hideLoading()));
    };
}
